module.exports = __webpack_public_path__ + "img/pdf-g01-graph.05cf6464.png";